module.exports = __webpack_public_path__ + "699ed5801f332f45d3e3bcac297d1655.jpg";